export default "__VITE_ASSET__D4c3SqsG__"